<template>
  <div class="content-item">
    <h2 class="heading">Create Church Finder Profile</h2>
    <p class="text">Great Job! Now we need you to create your church finder profile. Please watch the training video and after you are done return back to this page.</p>
    <div class="radio-group">
      <div class="row">
        <p class="text"><a class="link-button" href="https://mytruelife.org/editProfile" target="_blank"> Click Here</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  name: 'Step3',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    doSelectCard(card) {
      this.$emit('onSelectCard', card);
    },
    doSetCardSelected(card) {
      this.selected = card;
      setTimeout(() => {
        this.$emit('onNextPage');
      }, 500);
    },
    submit() {
      this.$emit('input', {
        ...this.value,
        card_back: this.selected.id,
      });
    },
  },
};
</script>
